import { createSlice } from '@reduxjs/toolkit';
import VwKullaniciRolyetkiDTO from 'src/models/RolYetki/VwKullaniciRolyetkiDTO';
import { kullaniciRolYetkiApi } from 'src/services/Auth/KullaniciRolYetkiApi';

export interface IArayuzAuthState {
  data: Array<VwKullaniciRolyetkiDTO>;
}

const MenuAuthSlice = createSlice<IArayuzAuthState, {}>({
  name: 'MenuAuthSlice',
  initialState: {
    data: []
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      kullaniciRolYetkiApi.endpoints.getVwKullaniciMenuyetki.matchFulfilled,
      (state, action) => {
        const data = action.payload.map((yetkiler) => {
          let m = {
            ...yetkiler
          };
          switch (m.yetkikodu) {
            case 'SYSTEMS':
              m.name = 'pages|menu|systems';
              m.link = '/systems';
              break;
            case 'HASTAKAYIT':
              m.name = 'pages|menu|hastaKayit';
              m.link = '/systems/hastakayit';
              break;
            case 'KURUMDISI':
              m.name = 'pages|menu|kurumdisi|kurumdisiislemler';
              m.link = '/systems/kurumdisi';
              break;
            case 'KURUMDISIHASTAKAYIT':
              m.name = 'pages|menu|kurumdisi|hastaKayit|hastaKayit';
              m.link = '/systems/kurumdisi/hasta-kayit';
              break;
            case 'KURUMDISIKARGOKURYEISLEMLERI':
              m.name = 'pages|menu|kurumdisi|kuryeIslemleri';
              m.link = '/systems/kurumdisi/kargo-kurye-islemleri';
              break;
            case 'KURUMDISIMURACAATIZLEM':
              m.name = 'pages|menu|kurumdisi|muracaatIzlem';
              m.link = '/systems/kurumdisi/muracaat-izleme';
              break;
            case 'KURUMDISIRAPORISTATISTIK':
              m.name = 'pages|menu|kurumdisi|raporIstatistik';
              m.link = '/systems/kurumdisi/rapor-istatistik';
              break;
            case 'VEZNEMODUL':
              m.name = 'pages|menu|veznemodul';
              m.link = '/systems/vezne-modul';
              break;
            case 'VEZNE':
              m.name = 'pages|menu|veznemodul/vezne';
              m.link = '/systems/vezne-modul/vezne';
              break;
            case 'VEZNEMAKBUZIZLEME':
              m.name = 'pages|menu|veznemodul/makbuzizleme';
              m.link = '/systems/vezne-modul/makbuz-izleme';
              break;
            case 'TEDAVIMODUL':
              m.name = 'pages|menu|tedavimodul';
              m.link = '/systems/tedavi-modul';
              break;
            case 'TEDAVI':
              m.name = 'pages|menu|tedavimodul/tedavi';
              m.link = '/systems/tedavi-modul/tedavi';
              break;
            case 'HEMSIREISLISTE':
              m.name = 'pages|menu|tedavimodul/hemsireisliste';
              m.link = '/systems/tedavi-modul/hemsire-is-listesi';
              break;
            case 'KARARDESTEK':
              m.name = 'pages|menu|kararDestek';
              m.link = '/systems/karar-destek';
              break;
            case 'KULLANICITANIM':
              m.name = 'pages|menu|kullaniciTanim';
              m.link = '/management/generals/kullanici-tanim';
              break;
            case 'PERSONELTANIM':
              m.name = 'pages|menu|personelTanim';
              m.link = '/management/generals/personel-tanim';
              break;
            case 'RANDEVU':
              m.name = 'pages|menu|randevu';
              m.link = '/systems/randevu';
              break;
            case 'FATURAMODUL':
              m.name = 'pages|menu|faturamodul';
              m.link = '/systems/faturamodul';
              break;
            case 'FATURA':
              m.name = 'pages|menu|fatura';
              m.link = '/systems/faturamodul/fatura';
              break;
            case 'FATURAIZLEME':
              m.name = 'pages|menu|faturaizleme';
              m.link = '/systems/faturamodul/faturaizleme';
              break;
            case 'FATURAKURUMICMALLERI':
              m.name = 'pages|menu|faturakurumicmalleri';
              m.link = '/systems/faturamodul/kurumicmalleri';
              break;
            case 'GUVENLIKTANIM':
              m.name = 'pages|menu|guvenlikTanim';
              m.link = '/management';
              break;
            case 'GENELTANIMLAR':
              m.name = 'pages|menu|genelTanimlar';
              m.link = '/management/generals';
              break;
            case 'VERIKONTROL':
              m.name = 'pages|menu|verikontrol';
              m.link = '/management/generals/verikontrol';
              break;
            case 'PARAMETRETANIM':
              m.name = 'pages|menu|parametreTanimlari';
              m.link = '/management/generals/gnlparametre';
              break;
            case 'SERVISTANIM':
              m.name = 'pages|menu|servisTanimlari';
              m.link = '/management/generals/servisTanim';
              break;
            case 'SERVISPERSONEL':
              m.name = 'pages|menu|servisPersonelTanimlari';
              m.link = '/management/generals/servisPersonel';
              break;
            case 'BRANSTANIM':
              m.name = 'pages|menu|bransTanimlari';
              m.link = '/management/generals/bransTanim';
              break;
            case 'KURUMTANIM':
              m.name = 'pages|menu|kurumTanimlari';
              m.link = '/management/generals/kurumTanim';
              break;
            case 'MODULTANIM':
              m.name = 'pages|menu|modulTanimlari';
              m.link = '/management/generals/modulTanim';
              break;
            case 'KURUMTARIFE':
              m.name = 'pages|menu|kurumTarife';
              m.link = '/management/generals/kurumTarife';
              break;
            case 'ORGANIZASYONTARIFE':
              m.name = 'pages|menu|organizasyonTarife';
              m.link = '/management/generals/organizasyontarife';
              break;
            case 'KULLANICITARIFE':
              m.name = 'pages|menu|kullaniciTarife';
              m.link = '/management/generals/kullanicitarife';
              break;
            case 'TARIFEISLEM':
              m.name = 'pages|menu|tarifeIslemTanim';
              m.link = '/management/generals/ucretTarifeIslem';
              break;
            case 'UCRETTARIFE':
              m.name = 'pages|menu|ucretTarifeTanim';
              m.link = '/management/generals/ucretTarifeTanim';
              break;
            case 'VEZNETANIM':
              m.name = 'pages|menu|vezneTanim';
              m.link = '/management/generals/veznetanim';
              break;
            case 'FATURATANIM':
              m.name = 'pages|menu|faturaTanim';
              m.link = '/management/generals/faturatanim';
              break;
            case 'INDIRIMTANIM':
              m.name = 'pages|menu|indirimTanim';
              m.link = '/management/generals/indirimtanim';
              break;
            case 'TANITANIM':
              m.name = 'pages|menu|tanitanim';
              m.link = '/management/generals/tanitanim';
              break;
            case 'DILISLEM':
              m.name = 'pages|menu|dilIslemleri';
              m.link = '/management/generals/dilIslem';
              break;
            case 'YATAKTANIM':
              m.name = 'pages|menu|yatak-tanim';
              m.link = '/management/generals/yatak-tanim';
              break;
            case 'KURUMMAILGONDERIMAYARLARI':
              m.name = 'pages|menu|kurumMailGonderimAyarlari';
              m.link = '/management/generals/kurumMailGonderimAyarlari';
              break;
            case 'SONUCIZLEMETANIM':
              m.name = 'pages|menu|sonucIzlemeTanim';
              m.link = '/management/generals/sonucIzlemeTanim';
              break;
            case 'TETKIKTANIMLARI':
              m.name = 'pages|menu|tetkikTanimlari';
              m.link = '/management/tetkik';
              break;
            case 'ISLEMTANIM':
              m.name = 'pages|menu|islemTanimlari';
              m.link = '/management/tetkik/islemtanimi';
              break;
            case 'ISLEMBOLUM':
              m.name = 'pages|menu|islemBolum';
              m.link = '/management/tetkik/islembolum';
              break;
            case 'ISLEMPANEL':
              m.name = 'pages|menu|istemPanelTanim';
              m.link = '/management/tetkik/istempaneltanim';
              break;
            case 'HIZMETPAKET':
              m.name = 'pages|menu|hizmetPaketTanimi';
              m.link = '/management/tetkik/pakettanim';
              break;
            case 'YETKILENDIRMELER':
              m.name = 'pages|menu|yetkilendirmeler';
              m.link = '/management/authority';
              break;
            case 'YETKITANIM':
              m.name = 'pages|menu|yetkiTanimlari';
              m.link = '/management/authority/yetkiTanim';
              break;
            case 'ROLTANIM':
              m.name = 'pages|menu|rolTanimlari';
              m.link = '/management/authority/roltanimlari';
              break;
            case 'ROLYETKI':
              m.name = 'pages|menu|rolYetkileri';
              m.link = '/management/authority/role';
              break;
            case 'KULLANICIROL':
              m.name = 'pages|menu|kullaniciRolYetkileri';
              m.link = '/management/authority/userrole';
              break;
            case 'KULLANICIVTYSYETKI':
              m.name = 'pages|menu|kullaniciVTYSYetkileri';
              m.link = '/management/authority/kullanicivtysyetki';
              break;
            case 'ORGYETKI':
              m.name = 'pages|menu|organizasyonYetkileri';
              m.link = '/management/authority/organization';
              break;
            case 'ISLEMLER':
              m.name = 'pages|menu|transactions';
              m.link = '/transactions';
              break;
            case 'KURUMBONUSTANIM':
              m.name = 'pages|menu|transactions|kurumBonusTanim|kurumBonusTanim';
              m.link = '/transactions/kurum-bonus-tanim';
              break;
            case 'DUYURU':
              m.name = 'pages|menu|duyurular';
              m.link = '/transactions/duyuruliste';
              break;
            case 'REZERVBARKOD':
              m.name = 'pages|menu|rezervbarkod';
              m.link = '/transactions/rezervbarkod';
              break;
            case 'DRHAKEDIS':
              m.name = 'pages|menu|rdHakedis';
              m.link = '/transactions/drhakedis';
              break;
            case 'POSCIHAZTANIM':
              m.name = 'pages|menu|poscihaztanim';
              m.link = '/transactions/poscihaztanim';
              break;
            case 'ISTEMPANELGORUNTULE':
              m.name = 'pages|menu|istempanel';
              m.link = '/transactions/istempanel';
              break;
            case 'LOGYONETIMI':
              m.name = 'pages|menu|logYonetimini';
              m.link = '/log';
              break;
            case 'LOGERROR':
              m.name = 'pages|menu|exception';
              m.link = '/log/exception';
              break;
            case 'EGITIM':
              m.name = 'pages|menu|egitim';
              m.link = '/log/egitim';
              break;
            case 'REFERANSDOKTOR':
              m.name = 'pages|menu|referansDoktor';
              m.link = '/management/generals/referans-doktor';
              break;
            case 'VEZNEYETKI':
              m.name = 'pages|menu|kullaniciVezneAtama';
              m.link = '/management/authority/kullanici-vezne-atama';
              break;
            case 'ORG':
              m.name = 'pages|menu|organizasyonTanim';
              m.link = '/management/generals/organizasyon-tanim';
              break;
            case 'LABIZLEM':
              m.name = 'pages|menu|laboratuvarIzleme';
              m.link = '/transactions/laboratuvar-izleme';
              break;
            case 'MURACAATIZLEM':
              m.name = 'pages|menu|muracaatIzleme';
              m.link = '/transactions/muracaat-izleme';
              break;
            case 'RAPORTIP':
              m.name = 'pages|menu|raporTipleri';
              m.link = '/management/tetkik/rapor-tipleri';
              break;
            case 'DIAGNOSISTANIM':
              m.name = 'pages|menu|teleDiagnosisTanim';
              m.link = '/management/generals/tele-diagnosis-tanim';
              break;
            case 'ECZANESTOK':
              m.name = 'pages|menu|eczanemodul';
              m.link = '/systems/stokeczane';
              break;
            case 'DEPODURUM':
              m.name = 'pages|menu|eczanemodul/depodurum';
              m.link = '/systems/stokeczane/depodurum';
              break;
            case 'DEPOTANIMLARI':
              m.name = 'pages|menu|eczanemodul/depotanimlari';
              m.link = '/systems/stokeczane/depotanimlari';
              break;
            case 'DEPODONEMLERI':
              m.name = 'pages|menu|eczanemodul/depodonemleri';
              m.link = '/systems/stokeczane/depodonemleri';
              break;
            case 'URUNTANIMLARI':
              m.name = 'pages|menu|eczanemodul/uruntanimlari';
              m.link = '/systems/stokeczane/uruntanimlari';
              break;
            case 'GIRISISLEMLERI':
              m.name = 'pages|menu|eczanemodul/girisislemleri';
              m.link = '/systems/stokeczane/girisislemleri';
              break;
            case 'CIKISISLEMLERI':
              m.name = 'pages|menu|eczanemodul/cikisislemleri';
              m.link = '/systems/stokeczane/cikisislemleri';
              break;
            case 'DEPOTALEP':
              m.name = 'pages|menu|eczanemodul/depotalep';
              m.link = '/systems/stokeczane/depotalep';
              break;
            case 'DEPOTALEPKABUL':
              m.name = 'pages|menu|eczanemodul/depotalepkabul';
              m.link = '/systems/stokeczane/depotalepkabul';
              break;
            case 'ORDERTALEPKABUL':
              m.name = 'pages|menu|eczanemodul/ordertalepkabul';
              m.link = '/systems/stokeczane/ordertalepkabul';
              break;
            case 'YATISKABUL':
              m.name = 'pages|menu|yatiskabul';
              m.link = '/systems/yatiskabul';
              break;
            case 'SERVISPROTOKOLTANIM':
              m.name = 'pages|menu|servisProtokolTanim';
              m.link = '/management/generals/servis-protokol-tanim';
              break;
            case 'PATOLOJIMODUL':
              m.name = 'pages|menu|patolojiModulu|patolojiModulu';
              m.link = '/systems/patoloji-modulu';
              break;
            case 'PATOLOJINUMUNEKABUL':
              m.name = 'pages|menu|patolojiModulu|numuneKabul';
              m.link = '/systems/patoloji-modulu/numune-kabul';
              break;
            case 'PATOLOJILABORATUVARISLEMLERI':
              m.name = 'pages|menu|patolojiModulu|laboratuvarIslemleri';
              m.link = '/systems/patoloji-modulu/laboratuvar-islemleri';
              break;
            case 'PATOLOJIRAPORISLEMLERI':
              m.name = 'pages|menu|patolojiModulu|raporIslemleri';
              m.link = '/systems/patoloji-modulu/rapor-islemleri';
              break;
            case 'PATOLOJIHASTARAPORSONUCLARI':
              m.name = 'pages|menu|patolojiModulu|hastaRaporSonuclari';
              m.link = '/systems/patoloji-modulu/hasta-rapor-sonuclari';
              break;
            case 'PATOLOJIARSIVLEME':
              m.name = 'pages|menu|patolojiModulu|arsivleme';
              m.link = '/systems/patoloji-modulu/arsivleme';
              break;
            case 'PATOLOJIARSIVLEMEDOLAPTANIM':
              m.name = 'pages|menu|patolojiModulu|dolapTanim';
              m.link = '/systems/patoloji-modulu/arsivleme/dolap-tanim';
              break;
            case 'PATOLOJIARSIVLEMEARSIVHAREKET':
              m.name = 'pages|menu|patolojiModulu|arsivHareketleri';
              m.link = '/systems/patoloji-modulu/arsivleme/arsiv-hareketleri';
              break;
            case 'PATOLOJIRAPORKURTAR':
              m.name = 'pages|menu|patolojiModulu|patolojiRaporKurtar';
              m.link = '/systems/patoloji-modulu/patoloji-rapor-kurtar';
              break;
            case 'RADYOLOJIMODUL':
              m.name = 'pages|menu|radyolojiModulu|radyolojiModulu';
              m.link = '/systems/radyoloji-modulu/';
              break;
            case 'RADYOLOJICIHAZTANIM':
              m.name = 'pages|menu|radyolojiModulu|cihazTanim';
              m.link = '/systems/radyoloji-modulu/cihaz-tanim';
              break;
            case 'RADYOLOJICIHAZTESTTANIM':
              m.name = 'pages|menu|radyolojiModulu|cihazTestTanim';
              m.link = '/systems/radyoloji-modulu/cihaz-test-tanim';
              break;
            case 'RADYOLOJIRANDEVUSABLON':
              m.name = 'pages|menu|radyolojiModulu|randevuSablonTanim';
              m.link = '/systems/radyoloji-modulu/randevu-sablon-tanim';
              break;
            case 'RADYOLOJICIHAZRANDEVU':
              m.name = 'pages|menu|radyolojiModulu|cihazRandevu';
              m.link = '/systems/radyoloji-modulu/cihaz-randevu';
              break;
            case 'RADYOLOJIKABUL':
              m.name = 'pages|menu|radyolojiModulu|radyolojikabul';
              m.link = '/systems/radyoloji-modulu/radyolojikabul';
              break;
            case 'RADYOLOJIISLEMLER':
              m.name = 'pages|menu|radyolojiModulu|radyolojiislemler';
              m.link = '/systems/radyoloji-modulu/radyolojiislemler';
              break;
            case 'MUHASEBEMODUL':
              m.name = 'pages|menu|muhasebeModulu|muhasebeModulu';
              m.link = '/systems/muhasebe-modul/';
              break;
            case 'HESAPPLAN':
              m.name = 'pages|menu|muhasebeModulu|hesapPlan';
              m.link = '/systems/muhasebe-modul/hesap-plan';
              break;
            case 'MUHASEBEISLEMLER':
              m.name = 'pages|menu|muhasebeModulu|muhasebeIslemler';
              m.link = '/systems/muhasebe-modul/muhasebe-islemler';
              break;
            case 'SONUCIZLEME':
              m.name = 'pages|menu|sonucIzleme|sonucIzleme';
              m.link = '/systems/sonuc-izleme';
              break;
            case 'MAILGONDERIMIZLEME':
              m.name = 'pages|menu|islemler|mailGonderIzleme|mailGonderIzleme';
              m.link = '/transactions/mail-gonderim-izleme';
              break;
            case 'SABLONTANIM':
              m.name = 'pages|menu|sablonTanim|sablonTanim';
              m.link = '/management/generals/sablon-tanim';
              break;
            case 'SOZLESMEIZLEME':
              m.name = 'pages|menu|islemler|sozlesmeIzleme|sozlesmeIzleme';
              m.link = '/transactions/sozlesme-izleme';
              break;
            default:
              m.link = '';
              break;
          }
          return m;
        });
        return {
          ...state,
          data
        };
      }
    );
  }
});
export default MenuAuthSlice;
